'use client'

import { clsx } from 'clsx'

interface Tab {
  id: string
  label: string
}

interface TabsProps {
  tabs: Tab[]
  active: string
  onChange: (id: string) => void
  className?: string
}

/** Underline tabs for content sections. Active = ink + black underline; rest muted. No gold. */
export function Tabs({ tabs, active, onChange, className }: TabsProps) {
  return (
    <div className={clsx('flex gap-6 sm:gap-7 border-b border-border-default overflow-x-auto', className)}>
      {tabs.map((t) => {
        const isActive = t.id === active
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={clsx(
              'pb-3 -mb-px border-b-2 text-[14px] whitespace-nowrap transition-colors',
              isActive
                ? 'border-brand-dark text-text-primary font-bold'
                : 'border-transparent text-text-muted font-semibold hover:text-text-primary'
            )}
          >
            {t.label}
          </button>
        )
      })}
    </div>
  )
}
